import React, { useEffect, useRef } from 'react';
const IntersectionTrigger = ({ onBottom, children }) => {
    const subject = useRef(null);
    useEffect(() => {
        const handleObserver = (entries) => {
            const target = entries[0];
            if (target.isIntersecting) {
                onBottom();
            }
        };
        const options = {
            root: null,
            rootMargin: '50px',
            threshold: 0,
        };
        const observer = new IntersectionObserver(handleObserver, options);
        const currentSubject = subject.current;
        if (currentSubject) {
            observer.observe(currentSubject);
        }
        return () => {
            if (currentSubject) {
                observer.unobserve(currentSubject);
            }
        };
    }, [onBottom]);
    return (React.createElement(React.Fragment, null,
        children,
        React.createElement("div", { ref: subject })));
};
export default IntersectionTrigger;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW50ZXJzZWN0aW9uVHJpZ2dlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0ludGVyc2VjdGlvblRyaWdnZXIvSW50ZXJzZWN0aW9uVHJpZ2dlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxLQUFLLEVBQUUsRUFBRSxTQUFTLEVBQUUsTUFBTSxFQUFFLE1BQU0sT0FBTyxDQUFDO0FBTWpELE1BQU0sbUJBQW1CLEdBQXdCLENBQUMsRUFBRSxRQUFRLEVBQUUsUUFBUSxFQUFFLEVBQUUsRUFBRTtJQUN4RSxNQUFNLE9BQU8sR0FBRyxNQUFNLENBQWlCLElBQUksQ0FBQyxDQUFDO0lBQzdDLFNBQVMsQ0FBQyxHQUFHLEVBQUU7UUFDWCxNQUFNLGNBQWMsR0FBRyxDQUFDLE9BQW9DLEVBQUUsRUFBRTtZQUM1RCxNQUFNLE1BQU0sR0FBRyxPQUFPLENBQUMsQ0FBQyxDQUFDLENBQUM7WUFDMUIsSUFBSSxNQUFNLENBQUMsY0FBYyxFQUFFLENBQUM7Z0JBQ3hCLFFBQVEsRUFBRSxDQUFDO1lBQ2YsQ0FBQztRQUNMLENBQUMsQ0FBQztRQUNGLE1BQU0sT0FBTyxHQUFHO1lBQ1osSUFBSSxFQUFFLElBQUk7WUFDVixVQUFVLEVBQUUsTUFBTTtZQUNsQixTQUFTLEVBQUUsQ0FBQztTQUNmLENBQUM7UUFDRixNQUFNLFFBQVEsR0FBRyxJQUFJLG9CQUFvQixDQUFDLGNBQWMsRUFBRSxPQUFPLENBQUMsQ0FBQztRQUNuRSxNQUFNLGNBQWMsR0FBRyxPQUFPLENBQUMsT0FBTyxDQUFDO1FBQ3ZDLElBQUksY0FBYyxFQUFFLENBQUM7WUFDakIsUUFBUSxDQUFDLE9BQU8sQ0FBQyxjQUFjLENBQUMsQ0FBQztRQUNyQyxDQUFDO1FBQ0QsT0FBTyxHQUFHLEVBQUU7WUFDUixJQUFJLGNBQWMsRUFBRSxDQUFDO2dCQUNqQixRQUFRLENBQUMsU0FBUyxDQUFDLGNBQWMsQ0FBQyxDQUFDO1lBQ3ZDLENBQUM7UUFDTCxDQUFDLENBQUM7SUFDTixDQUFDLEVBQUUsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDO0lBRWYsT0FBTyxDQUNIO1FBQ0ssUUFBUTtRQUNULDZCQUFLLEdBQUcsRUFBRSxPQUFPLEdBQUksQ0FDdEIsQ0FDTixDQUFDO0FBQ04sQ0FBQyxDQUFDO0FBRUYsZUFBZSxtQkFBbUIsQ0FBQyJ9